import { writable } from "svelte/store";

export const ActiveVisualizer = writable("");
